import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SocialPostsComponent } from 'app/modules/social/components/social-posts/social-posts.component';
import { ProjectResolver } from 'app/modules/project/resolvers/project-resolver';
import { SocialService } from 'app/modules/social/services/social.service';
import { InstaAuthComponent } from 'app/modules/social/components/insta-auth/insta-auth.component';
import { RoleGuard } from '../auth/guards/role.guard';

const routes: Routes = [
  {
    path: 'project/:id/social',
    component: SocialPostsComponent,
    canActivate: [RoleGuard],
    data: {
      authorizedRoles: ['administrator', 'archive-editor'],
    },
    resolve: {
      project: ProjectResolver,
      socialLinks: SocialService,
    },
  },
  {
    path: 'instaAuth',
    component: InstaAuthComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class SocialRoutingModule {}
